<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div>
        <app-input-text [control]="form.get('first_name')" name="contact_first_name" [disabled]="disabled" [autoFocus]="true"></app-input-text>
        <app-input-text [control]="form.get('last_name')" name="contact_last_name" [disabled]="disabled"></app-input-text>
        <app-input-text [control]="form.get('email')" name="contact_email" [disabled]="disabled"></app-input-text>
        <app-input-select [options]="permissionOptions"
                          [control]="form.get('mypascom_account')"
                          name="contact_mypascom_account"
                          optionValue="value"
        ></app-input-select>
    </div>
    @if (!disabled) {
      <div class="d-flex justify-content-end mt-3">
          <ng-content></ng-content>
          <app-button-submit [invalid]="form.invalid" [label]="submitButtonLabel"></app-button-submit>
      </div>
    }
</form>
